// Text wraps in whole lines, so its height is a staircase rather than a
// continuous function. Try each measured height as an uncropped image width.
export function fitPortraitWidth(width, aspectRatio, measureTextHeight, { minFraction = 0.28, maxFraction = 0.48 } = {}) {
  const min = width * minFraction;
  const max = width * maxFraction;
  let bestWidth = width * 0.39;
  let bestError = Infinity;
  const measure = (candidate) => {
    const height = measureTextHeight(candidate);
    const error = Math.abs(height - candidate / aspectRatio);
    if (error < bestError) {
      bestWidth = candidate;
      bestError = error;
    }
    return height;
  };
  for (let step = 0; step <= 20; step += 1) {
    const candidate = min + (max - min) * step / 20;
    const matchingWidth = measure(candidate) * aspectRatio;
    if (matchingWidth >= min && matchingWidth <= max) measure(matchingWidth);
    if (bestError < 0.5) break;
  }
  return bestWidth;
}

export function observePortraitLayout(intro, copy, photo, {
  property = '--about-portrait-width',
  minWidth = 769,
  fallbackAspectRatio = 2972 / 3963,
  minFraction = 0.28,
  maxFraction = 0.48,
} = {}) {
  let stopped = false;
  let frame = 0;
  let lastWidth = -1;
  const desktop = window.matchMedia(`(min-width: ${minWidth}px)`);
  const update = () => {
    if (stopped) return;
    if (!desktop.matches) {
      intro.style.removeProperty(property);
      lastWidth = -1;
      return;
    }
    const width = intro.getBoundingClientRect().width;
    if (!width || width === lastWidth) return;
    lastWidth = width;
    const aspectRatio = photo.naturalWidth && photo.naturalHeight
      ? photo.naturalWidth / photo.naturalHeight
      : fallbackAspectRatio;
    const portraitWidth = fitPortraitWidth(width, aspectRatio, (candidate) => {
      intro.style.setProperty(property, `${candidate}px`);
      return copy.offsetHeight;
    }, { minFraction, maxFraction });
    intro.style.setProperty(property, `${portraitWidth}px`);
  };
  const schedule = () => {
    cancelAnimationFrame(frame);
    frame = requestAnimationFrame(update);
  };
  const refresh = () => {
    lastWidth = -1;
    schedule();
  };
  const observer = typeof ResizeObserver === 'undefined' ? null : new ResizeObserver(schedule);
  observer?.observe(intro);
  window.addEventListener('resize', schedule, { passive: true });
  photo.addEventListener('load', refresh);
  document.fonts?.addEventListener('loadingdone', refresh);
  document.fonts?.ready.then(() => { if (!stopped) refresh(); });
  update();
  return () => {
    stopped = true;
    cancelAnimationFrame(frame);
    observer?.disconnect();
    window.removeEventListener('resize', schedule);
    photo.removeEventListener('load', refresh);
    document.fonts?.removeEventListener('loadingdone', refresh);
  };
}
